export const JABVOX_SET_USER = 'JABVOX_SET_USER';
export const JABVOX_RESET = 'JABVOX_RESET';

export const ANALYTICS_IDENTITY = 'ANALYTICS_IDENTITY';
export const ANALYTICS_RESET = 'ANALYTICS_RESET';
